<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 17L1 21V5L8 1M8 17L14 21M8 17V1M14 21L21 17V1L14 5M14 21V5M14 5L8 1" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
